<template>
  <div class="width-100p">
    <v-tooltip bottom :disabled="!isDisabled">
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-btn
            depressed
            large
            block
            color="white"
            class="ma-0"
            :disabled="isDisabled"
            @click="openPdf"
          >
            OMP Financial Data SQ
          </v-btn>
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
    <p
      v-if="intentText"
      class="text--secondary text-caption text-center mt-1 mb-0"
    >
      {{ intentText }}
    </p>
  </div>
</template>

<script>
  import {
    OM_PROTECT_STORE_PDF_URL_QUERY,
    MARK_OM_PROTECT_PDF_DOWNLOADED_MUTATION,
  } from '../../../constants/graphql/om_protect';

  export default {
    name: 'DownloadOmProtectPdf',
    props: {
      testator: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        loading: true,
        url: null,
        status: null,
      };
    },
    computed: {
      isDisabled() {
        return this.loading || this.status !== 'ready' || !this.url;
      },
      tooltipText() {
        if (this.loading) {
          return 'Loading…';
        }
        if (this.status === 'not_started') {
          return 'Testator has not completed it.';
        }
        if (this.status === 'not_interested') {
          return 'Client has not expressed interest.';
        }
        if (this.status === 'processing') {
          return 'Generating PDF — please try again shortly.';
        }
        return 'No financial data PDF available yet.';
      },
      intentText() {
        const store = this.testator?.omProtectStore;
        if (!store) return null;
        return store.skipped
          ? 'Client was not interested'
          : 'Client was interested';
      },
    },
    mounted() {
      this.$apollo
        .query({
          query: OM_PROTECT_STORE_PDF_URL_QUERY,
          variables: { testatorId: this.testator.id },
          fetchPolicy: 'network-only',
        })
        .then(response => {
          this.url = response.data.omProtectStorePdfUrl.url;
          this.status = response.data.omProtectStorePdfUrl.status;
        })
        .catch(error => {
          console.error('Error fetching OMP protect PDF URL:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    methods: {
      openPdf() {
        this.$apollo
          .mutate({
            mutation: MARK_OM_PROTECT_PDF_DOWNLOADED_MUTATION,
            variables: { testatorId: this.testator.id },
          })
          .catch(error => {
            console.error(
              'Error marking OMP protect PDF as downloaded:',
              error
            );
          });
        window.open(this.url, '_blank');
      },
    },
  };
</script>
